<!-- src/app/components/mi-map/mi-map.component.html -->
<div class="mi-map">

  <!-- LEGEND -->
  <div class="map-legend">
    <span class="legend-item legend-item--captain">
      <span class="legend-dot"></span> Has Captain ({{ captainCount }})
    </span>
    <span class="legend-item legend-item--active">
      <span class="legend-dot"></span> Actively Canvassing ({{ activeCount }})
    </span>
    <span class="legend-item legend-item--none">
      <span class="legend-dot"></span> Needs Captain ({{ noneCount }})
    </span>
  </div>

  <!-- COUNTY GRID (visual map approximation) -->
  <div class="county-grid">
    <button
      *ngFor="let county of counties"
      class="county-tile"
      [class.county-tile--captain]="county.status === 'captain'"
      [class.county-tile--active]="county.status === 'active'"
      [class.county-tile--none]="county.status === 'none'"
      [class.county-tile--selected]="selectedCounty?.name === county.name"
      (click)="select(county)"
      [attr.title]="county.name + ' - ' + statusLabel(county.status)"
    >
      <span class="county-tile__name">{{ county.name }}</span>
    </button>
  </div>

  <!-- SELECTED COUNTY DETAIL -->
  <div *ngIf="selectedCounty" class="county-detail">
    <div class="county-detail__header">
      <strong>{{ selectedCounty.name }} County</strong>
      <span class="county-detail__status" [class]="'county-detail__status--' + selectedCounty.status">
        {{ statusLabel(selectedCounty.status) }}
      </span>
    </div>
    <p *ngIf="selectedCounty.status === 'none'" class="county-detail__cta">
      This county needs a Constitutional Captain.
      <a routerLink="/volunteer">Sign up to lead {{ selectedCounty.name }} County.</a>
    </p>
    <p *ngIf="selectedCounty.status === 'captain'" class="county-detail__cta county-detail__cta--good">
      Great news! {{ selectedCounty.name }} County has a Constitutional Captain knocking doors.
    </p>
    <p *ngIf="selectedCounty.status === 'active'" class="county-detail__cta">
      {{ selectedCounty.name }} County is actively canvassing. Want to help?
      <a routerLink="/volunteer">Join the effort.</a>
    </p>
  </div>

  <!-- SUMMARY LISTS -->
  <div class="map-summary">
    <div *ngIf="captainCounties.length > 0" class="summary-col">
      <h4 class="summary-col__title summary-col__title--captain">Counties with Captains</h4>
      <ul>
        <li *ngFor="let c of captainCounties">{{ c.name }}</li>
      </ul>
    </div>
    <div *ngIf="activeCounties.length > 0" class="summary-col">
      <h4 class="summary-col__title summary-col__title--active">Actively Canvassing</h4>
      <ul>
        <li *ngFor="let c of activeCounties">{{ c.name }}</li>
      </ul>
    </div>
    <div class="summary-col">
      <h4 class="summary-col__title summary-col__title--none">Open Counties</h4>
      <p class="summary-col__note">{{ noneCount }} counties still need captains.</p>
      <a routerLink="/volunteer" class="btn-map">Step Up for Your County</a>
    </div>
  </div>

</div>
